import { useImperativeHandle, useRef, forwardRef, Ref } from "react";
import { StripeCardNumberElement, StripeCardExpiryElement, StripeCardCvcElement } from "@stripe/stripe-js";
import { CardNumberElement, CardExpiryElement, CardCvcElement } from "@stripe/react-stripe-js";

type StripeElement = typeof CardNumberElement | typeof CardExpiryElement | typeof CardCvcElement;

type StripeElementInstance = StripeCardNumberElement | StripeCardExpiryElement | StripeCardCvcElement;

interface StripeInputProps {
    component: StripeElement;
    inputRef?: Ref<{ focus: () => void }>;
}

const StripeInput = forwardRef<{ focus: () => void }, StripeInputProps>(
    ({ component: Component, inputRef, ...props }, ref) => {
        const elementRef = useRef<StripeElementInstance>();

        useImperativeHandle(inputRef || ref, () => ({
            focus: () => {
                if (elementRef.current?.focus) {
                    elementRef.current.focus();
                }
            },
        }));

        return <Component onReady={(element: StripeElementInstance) => (elementRef.current = element)} {...props} />;
    }
);

StripeInput.displayName = "StripeInput";

export default StripeInput;
